import {getFileUrl} from '../api/file';
import md5 from 'js-md5';
import axios from 'axios';
import {i18n} from '@/lang/index';

const baseTask = `/mgr/task-engine`

export const getQueryStringByName = function (name) {
    var result = location.search.match(new RegExp('[?&]' + name + '=([^&]+)', 'i'))
    if (result == null || result.length < 1) {
        return ''
    }
    return result[1]
}

export const transformData = function (data) {
    const params = new FormData()
    for (const item in data) {
        params.append(item, data[item])
    }
    return params
}

export const DateFormat = function (date, fmt) {
    fmt = fmt || 'yyyy-MM-dd hh:mm:ss'
    if (date === null || typeof date === 'undefined' || date === '') {
        return null
    } else {
        // 时间要转成obj，否则报错
        date = new Date(date)
    }
    var o = {
        'M+': date.getMonth() + 1, // 月
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        S: date.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
        }
    }
    return fmt
}
export const openLink = (url) => {
    window.open(url, 'blank')
}
// 转换文件地址并在浏览器中打开下载
export const handleTransUrlAndDownLoadFile = (url) => {
    const query = {
        url
    }
    getFileUrl(query).then(res => {
        if (res.data.code === 0) {
            const url = res.data.data.data
            openLink(url)
        }
    })
}

// 转换文件下载地址
export function getFileUrlLarger(bucketName, fileName) {
    return request({
        url: `${base}/base/getFileUrl?url=${bucketName}_${fileName}`, method: 'get',
    })
}

/**
 * 分片上传函数 支持多个文件
 * @param options
 * options.file 表示源文件
 * options.pieceSize 表示需要分片的大小 默认是5m
 * options.fileUrl 整个文件的上传地址
 * progress 进度回调
 * success 成功回调
 * error 失败回调
 */
export const uploadByPieces = ({files, pieceSize = 5, progress, success, error}) => {
    if (!files || !files.length) return
    // 上传过程中用到的变量
    let fileList = [] // 总文件列表
    let progressNum = 1 // 进度
    let successAllCount = 0 // 上传成功的片数
    // let currentAllChunk = 0 // 当前上传的片数索引
    let AllChunk = 0 // 所有文件的chunk数之和
    let AllFileSize = 0 // 所有文件size


    // 获取md5
    const readFileMD5 = (files) => {
        // 读取每个文件的md5
        files.map((file, index) => {
            let fileRederInstance = new FileReader()
            fileRederInstance.readAsBinaryString(file)
            fileRederInstance.addEventListener('load', e => {
                let fileBolb = e.target.result
                let fileMD5 = md5(fileBolb)
                if (!fileList.some((arr) => arr.md5 === fileMD5)) {
                    fileList.push({md5: fileMD5, name: file.name, file})
                    AllFileSize = AllFileSize + file.size
                }
                if (index === files.length - 1) readChunkMD5(fileList)
            }, false)
        })
    }
    const getChunkInfo = (file, currentChunk, chunkSize) => {
        let start = currentChunk * chunkSize
        let end = Math.min(file.size, start + chunkSize)
        let chunk = file.slice(start, end)
        return {start, end, chunk}
    }
    // 针对每个文件进行chunk处理
    const readChunkMD5 = (fileList) => {
        fileList.map((currentFile, fileIndex) => {
            const chunkSize = pieceSize * 1024 * 1024 // 5MB一片
            const chunkCount = Math.ceil(currentFile.file.size / chunkSize) // 总片数

            const certificateData = {
                filename: currentFile.name, num: chunkCount,
            }
            getCertificate(certificateData).then(async res => {
                if (res.data.code === 0) {
                    AllChunk = AllChunk + chunkCount // 计算全局chunk数
                    // let fileSize = currentFile.file.size // 文件大小
                    // 针对单个文件进行chunk上传
                    const resData = res.data.data

                    for (let i = 0; i < chunkCount; i++) {
                        const {chunk} = getChunkInfo(currentFile.file, i, chunkSize)
                        // let chunkFR = new FileReader()
                        // chunkFR.readAsBinaryString(chunk)
                        // chunkFR.addEventListener('load', e => {
                        //   let chunkBolb = e.target.result
                        //   let chunkMD5 = md5(chunkBolb)
                        //   // this.readingFile = false
                        //
                        //   // bucketName: "manage"
                        //   // createTime: 1614309462937
                        //   // fileName: "bigfile/2021-02-26/0f948cdcb4f24db5be41d1833aeb8d9a.zip"
                        //   // originFileName: "任务管理系统 - 副本.zip"
                        //   // partNumber: 0
                        //   // totalPartNumber: 12
                        //   // uploadId: "345cc3b7-ee67-463b-b641-e5c3ff2f5e05"
                        //
                        //   uploadChunk(currentFile, {chunkMD5, chunk, currentChunk: i, chunkCount}, fileIndex, resData)
                        // }, false)
                        await uploadChunk(currentFile, {chunk, currentChunk: i, chunkCount}, fileIndex, resData)
                    }
                }
            }).catch(e => {
                error && error(e)
            })
        })
    }
    // 更新进度
    const progressFun = (currentFile) => {
        progressNum = Math.ceil(successAllCount / AllChunk * 100)
        progress(progressNum, currentFile)
    }
    // 对分片已经处理完毕的文件进行上传
    // const uploadFile = (currentFile) => {
    //   let makeFileForm = new FormData()
    //   makeFileForm.append('file', currentFile.file)
    //
    //   fileUpload(makeFileForm).then(res => {
    //     progressFun()
    //     res.file_name = currentFile.name
    //     success && success(res)
    //     successAllCount++
    //   }).catch(e => {
    //     error && error(e)
    //   })
    // }
    const uploadChunk = (currentFile, chunkInfo, fileIndex, {bucketName, uploadId, partNumber, fileName}) => {
        currentFile.fileName = fileName
        return new Promise((resolve, reject) => {
            let fetchForm = new FormData()
            fetchForm.append('file', chunkInfo.chunk)
            // const chunkUrl = `/uploadPart/{bucketName}/{uploadId}/{partNumber}`
            const chunkUrl = `${config.uploadFileServer}/uploadPart/${bucketName}/${uploadId}/${chunkInfo.currentChunk + 1}`

            axios({
                url: chunkUrl, method: 'post', headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }, data: fetchForm,
            })
                .then(res => {
                    resolve(res)
                    progressFun(currentFile)
                    if (chunkInfo.currentChunk <= chunkInfo.chunkCount - 1) {
                        successAllCount++
                        if (chunkInfo.currentChunk + 1 === chunkInfo.chunkCount) {
                            const successData = {
                                bucketName, fileName, name: currentFile.name, size: AllFileSize,
                            }
                            success && success(successData)
                        }
                    }
                }).catch((e) => {
                error && error(e)
                reject(e)
            })
        })

    }
    readFileMD5(files) // 开始执行代码
}

/**
 * 文件大小转换
 * @param   fileByte    {Number} 文件byte
 * @return  {String}
 * */
export function getFileSize(fileByte) {
    var fileSizeByte = fileByte;
    var fileSizeMsg = "";
    if (fileSizeByte < 1048576) fileSizeMsg = (fileSizeByte / 1024).toFixed(2) + "KB"; else if (fileSizeByte == 1048576) fileSizeMsg = "1MB"; else if (fileSizeByte > 1048576 && fileSizeByte < 1073741824) fileSizeMsg = (fileSizeByte / (1024 * 1024)).toFixed(2) + "MB"; else if (fileSizeByte > 1048576 && fileSizeByte == 1073741824) fileSizeMsg = "1GB"; else if (fileSizeByte > 1073741824 && fileSizeByte < 1099511627776) fileSizeMsg = (fileSizeByte / (1024 * 1024 * 1024)).toFixed(2) + "GB"; else fileSizeMsg = "文件超过1TB";
    return fileSizeMsg;
}

// 获取文件后缀名 "xxx.png"  => ".png"
export const getFileSuffix = (filename) => {
    return filename.substring(filename.lastIndexOf("."), filename.length)
}


// 邮箱截取 前缀 xxx@qq.com> => xxx
export function getMailPrefix(str) {
    if (!str) return ''
    const reg = /^(\w)+(\.\w+)*/g
    if (!reg.test(str)) return ''
    return str.match(reg)[0]
}

// 邮箱截取 aaa<bbb@qq.com> => bbb@qq.com
export function getMailStr(str) {
    const reg = /([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})/g
    return str.match(reg) ? (str.match(reg)[0]) : ''
}

// 换行 '↵' => '\n'
export const transEnterTextBr = (str) => {
    return str.replace(/(\r\n|\n|\r)/gm, "<br />")
}

/**
 * xss 过滤
 * */
export const xssFilter = (htmlStr) => {
    const whiteList = xss.getDefaultWhiteList()
    const myWhiteList = JSON.parse(JSON.stringify(whiteList))
    const keys = Object.keys(myWhiteList)
    keys.forEach(key => {
        myWhiteList[key].push('style')
    })
    const myxss = new xss.FilterXSS({
        whiteList: myWhiteList, css: true
    })
    return myxss.process(htmlStr)
}

const CNDateDay2 = [{week: '星期日', num: 0}, {week: '星期一', num: 1}, {week: '星期二', num: 2}, {
    week: '星期三', num: 3
}, {week: '星期四', num: 4}, {week: '星期五', num: 5}, {week: '星期六', num: 6}]


export const formatToCNDateDay2 = (dateDay) => {
    let str = ''
    CNDateDay2.forEach(item => {
        if (item.num === dateDay) {
            str = item.week
        }
    })
    return str
}


export function getTextWidth(text, font) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    context.font = font; // 设置字体样式，必须设置为与实际文本相同的样式
    const width = context.measureText(text).width.toFixed(0)
    console.log(width, 'text', text)
    return width;
}

export function getTextLength(str) {
    if (!str) return 0; // 排除 null、undefined、''

    let len = 0;
    for (let i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) > 127 || str.charCodeAt(i) === 94) {
            len += 2;
        } else {
            len += 1;
        }
    }
    return len;
}

export function formatText(str, limit = 9, isTag) {
    let len = 0;
    let result = '';
    let limitTag = 0;
    if (isTag) {
        limitTag = limit - 9
    } else {
        limitTag = limit
    }
    for (let i = 0; i < str.length; i++) {
        const char = str[i];
        len += char.charCodeAt(0) > 127 ? 2 : 1;
        if (len > limitTag * 2) { // 中文占2，英文占1，9个字 = 18长度
            result += '...';
            break;
        }
        result += char;
    }
    return result;
}

export function getColumnWidth(itemValue, tableData, label, type) {
    switch (itemValue) {
        case 'customerType':
        case 'customerCode':
        case 'customerOrigin':
            return 160;
        case 'createName':
            return 80;
        case 'customerLevel':
            return 80;
        case 'maiContactVOList':
            return 70;
        case 'mangerVOList':
            if (type === 'public') {
                return 100;
            } else {
                return 70;
            }
        case "lastTime":
            return 150;
        case "setting":
            return 120;
        case "zoneAddress":
            return 80;
        case "applyTime":
            return 150;
        case "followTime":
            return 150;
        case "auditName":
            return 70;
        case "userName":
            return 70;
        case "auditStatus":
            return 120;
        default:
            return 'auto'
        // flexWidth(itemValue, tableData, label);
    }
}

// ai 对话详情 到 对话框

export function processChatData(data) {
    const processedData = [];
    const questionMap = {};

    data.forEach(item => {
        const {question, content} = item;

        // 处理 Client 部分
        if (!questionMap[question]) {
            questionMap[question] = {
                key: "Client", content: question
            };
            processedData.push(questionMap[question]);
        }

        // 处理 AI 部分
        let lastItem = processedData[processedData.length - 1];
        if (lastItem.key === "AI" && lastItem.isArray) {
            lastItem.content.push({
                key: "AI", content, isCompletedAIChat: true
            });
        } else if (lastItem.key === "AI" && !lastItem.isArray) {
            lastItem.isArray = true;
            lastItem.content = [{key: "AI", content: lastItem.content, isCompletedAIChat: true}, {
                key: "AI", content, isCompletedAIChat: true
            }];
        } else {
            processedData.push({
                key: "AI", isArray: false, content, isCompletedAIChat: true
            });
        }
    });

    // 如果 AI 的 content 只有一条回复，则取消 isArray
    processedData.forEach(item => {
        if (item.key === "AI" && item.isArray && item.content.length === 1) {
            item.isArray = false;
            item.content = item.content[0].content;
        }
    });

    return processedData;
}


/**
 * 文件 置顶排序
 * @param folders
 * @returns {*}
 */
export function sortFolders(folders) {
    if (folders) {
        return folders.slice().sort((a, b) => {
            // 判断是否都为置顶
            if (a.isTop === 1 && b.isTop === 1) {
                // orderNum 越小越靠前，null 视为无穷大
                const aOrder = a.orderNum !== null ? a.orderNum : Infinity;
                const bOrder = b.orderNum !== null ? b.orderNum : Infinity;
                return aOrder - bOrder;
            }

            // 只有 a 是置顶，a 靠前
            if (a.isTop === 1 && b.isTop !== 1) {
                return -1;
            }

            // 只有 b 是置顶，b 靠前
            if (a.isTop !== 1 && b.isTop === 1) {
                return 1;
            }

            // 都不是置顶，不变顺序
            return 0;
        });
    } else {
        return folders
    }
}

/**
 * 高亮关键词
 * @param {String} text 要处理的文本
 * @param {String} keyword 关键词
 * @param {String} [highlightClass='highlight'] 高亮的 class 名，默认 highlight
 * @returns {String} 返回带高亮的 HTML 字符串
 */
export function highlightKeyword(text, keyword, highlightClass = 'highlight_search') {
    if (!keyword) return text
    const escapedKeyword = keyword.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') // 防止正则出错
    const reg = new RegExp(`(${escapedKeyword})`, 'gi')
    console.log(text, text.replace(reg, `<span class="${highlightClass}">$1</span>`), 'ddddd')
    return text.replace(reg, `<span class="${highlightClass}">$1</span>`)
}


/**
 * 分段注入 HTML，支持间隔延迟，避免卡顿
 * @param targetRef Vue 的 ref 目标
 * @param html 要注入的 HTML 内容
 * @param chunkSize 每段大小，默认 10000 字符
 * @param delay 每段之间的延迟时间（ms），默认 30ms
 * @param done 注入完成后的回调
 */
// export default function createGradualInjector(contentHtml, html, templateHtml, chunkSize = 16000) {
//     contentHtml.value = ''
//     let index = 0
//     const totalLength = html.length
//     // 最小的长度是 模版的长度
//     const chunkSizeComputed = templateHtml?.length + html.length < chunkSize ? html.length : html.length * 0.3 > chunkSize ? chunkSize : html.length;
//     const totalChunks = Math.ceil(totalLength / chunkSizeComputed)
//
//     const injectNextChunk = (editor) => {
//         if (index >= totalLength) return false
//
//         // 重新获取当前用户已有的内容
//         let currentContent = ""
//         if (index === 0) {
//             // 第一次切片
//             currentContent = ""
//         } else {
//             // 后面的切片
//             currentContent = editor.getContent() || ''
//             console.log(editor, currentContent, 'editorRef')
//         }
//
//         // 当前要注入的切片
//         const chunk = html.slice(index, index + chunkSizeComputed)
//
//         // 直接通过 editor API 更新内容
//         const newContent = currentContent + chunk
//
//         // 同步外部状态
//         contentHtml.value = newContent
//
//         index += chunkSizeComputed
//         return true
//     }
//
//     const hasMore = () => index < totalLength
//
//     const getStatus = () => {
//         const currentChunk = Math.floor(index / chunkSizeComputed)
//         const remainingChunks = totalChunks - currentChunk
//         const injectedContent = contentHtml.value
//         const remainingContent = html.slice(index)
//
//         return {
//             totalChunks,
//             currentChunk,
//             remainingChunks,
//             injectedContent,
//             remainingContent,
//             progress: `${currentChunk}/${totalChunks}`,
//         }
//     }
//
//     return {
//         injectNextChunk, hasMore, getStatus,
//     }
// }

// 切片优化
// export default function createGradualInjector(contentHtml, html, templateHtml, chunkSize = 16000) {
//     contentHtml.value = ''
//     let index = 0
//     const totalLength = html.length
//
//     // 根据你的逻辑动态计算 chunk size
//     const chunkSizeComputed = templateHtml?.length + html.length < chunkSize ? html.length : html.length * 0.3 > chunkSize ? chunkSize : html.length
//
//     const totalChunks = Math.ceil(totalLength / chunkSizeComputed)
//
//     /**
//      * 安全切片：保证不会切断 "<tag ...>"
//      */
//     const getSafeSliceEnd = (start) => {
//         let end = start + chunkSizeComputed
//
//         if (end >= totalLength) return totalLength
//
//         // 尝试往右扩展，直到遇到 '>'
//         while (end < totalLength) {
//             const char = html[end]
//             if (char === '>') {
//                 end += 1
//                 break
//             }
//             end++
//         }
//
//         return end
//     }
//
//     const injectNextChunk = (editor) => {
//         if (index >= totalLength) return false
//
//         let currentContent = ""
//         if (index !== 0) {
//             currentContent = editor.getContent() || ''
//         }
//
//         // 关键改动
//         const safeEnd = getSafeSliceEnd(index)
//         const chunk = html.slice(index, safeEnd)
//         const newContent = currentContent + chunk
//
//         contentHtml.value = newContent
//         index = safeEnd
//
//         return true
//     }
//
//     const hasMore = () => index < totalLength
//
//     const getStatus = () => {
//         const currentChunk = Math.floor(index / chunkSizeComputed)
//         const remainingChunks = totalChunks - currentChunk
//
//         return {
//             totalChunks,
//             currentChunk,
//             remainingChunks,
//             injectedContent: contentHtml.value,
//             remainingContent: html.slice(index),
//             progress: `${currentChunk}/${totalChunks}`,
//         }
//     }
//
//     return {
//         injectNextChunk, hasMore, getStatus,
//     }
// }

/**
 * 优化版：分段注入 HTML 内容到编辑器
 * @param {Ref} contentHtml - Vue ref，用于存储当前内容
 * @param {string[]} contents - 分页后的内容数组
 * @returns {{injectNextChunk: function, hasMore: function, getStatus: function, reset: function, getPerformanceStats: function}}
 */
export default function createGradualInjector(contentHtml, contents) {
    contentHtml.value = "";
    
    // ✅ 增加输入验证
    if (!contents || !Array.isArray(contents) || contents.length === 0) {
        console.error('❌ createGradualInjector: contents 参数无效', contents);
        return {
            injectNextChunk: () => false,
            hasMore: () => false,
            getStatus: () => ({
                totalPages: 0,
                currentPage: 0,
                remainingPages: 0,
                injectedContent: '',
                remainingContent: '',
                progress: '0/0',
                percentage: 100,
            }),
            getPerformanceStats: () => ({
                totalInjections: 0,
                totalTime: '0ms',
                averageTime: '0ms',
                minTime: '0ms',
                maxTime: '0ms',
                injectionTimes: [],
            }),
            reset: () => {},
        };
    }
    
    // ✅ 过滤空内容
    const validContents = contents.filter(c => c && typeof c === 'string' && c.trim() !== '');
    
    if (validContents.length === 0) {
        console.warn('⚠️ createGradualInjector: 所有内容块都为空');
        return {
            injectNextChunk: () => false,
            hasMore: () => false,
            getStatus: () => ({
                totalPages: 0,
                currentPage: 0,
                remainingPages: 0,
                injectedContent: '',
                remainingContent: '',
                progress: '0/0',
                percentage: 100,
            }),
            getPerformanceStats: () => ({
                totalInjections: 0,
                totalTime: '0ms',
                averageTime: '0ms',
                minTime: '0ms',
                maxTime: '0ms',
                injectionTimes: [],
            }),
            reset: () => {},
        };
    }
    
    let pageIndex = 0; // 当前页数（从 0 开始）
    const totalPages = validContents.length;
    
    // 性能统计
    const performanceStats = {
        injectionTimes: [], // 每次注入耗时
        totalTime: 0,       // 总耗时
        startTime: null,    // 开始时间
    };

    /**
     * 注入下一个内容块
     * @param {Object} editor - TinyMCE 编辑器实例
     * @returns {boolean} - 是否成功注入
     */
    const injectNextChunk = (editor) => {
        if (pageIndex >= totalPages) {
            console.log('✅ 所有内容已注入完成');
            return false;
        }
        
        // ✅ 增加编辑器验证
        if (!editor || typeof editor.getContent !== 'function' || typeof editor.setContent !== 'function') {
            console.error('❌ 编辑器实例无效');
            return false;
        }

        const startTime = performance.now();
        
        // 第一次注入时记录开始时间
        if (pageIndex === 0) {
            performanceStats.startTime = startTime;
        }

        try {
            // 获取当前编辑器内容
            const currentContent = pageIndex === 0 ? '' : (editor.getContent() || '');

            // 当前页内容（使用 validContents）
            const pageContent = validContents[pageIndex];

            if (!pageContent) {
                console.warn(`⚠️ 第 ${pageIndex + 1} 页内容为空，跳过`);
                pageIndex++;
                return pageIndex < totalPages; // 继续尝试下一页
            }

            // 累加内容
            const newContent = currentContent + pageContent;

            // 更新编辑器内容
            editor.setContent(newContent);

            // 同步到 ref
            contentHtml.value = newContent;

            const endTime = performance.now();
            const duration = endTime - startTime;
            
            performanceStats.injectionTimes.push(duration);
            performanceStats.totalTime = endTime - (performanceStats.startTime || startTime);

            console.log(`✅ 已注入第 ${pageIndex + 1}/${totalPages} 页`, {
                contentLength: pageContent.length,
                sizeInKB: (pageContent.length / 1024).toFixed(2) + 'KB',
                injectionTime: duration.toFixed(2) + 'ms',
                totalTime: performanceStats.totalTime.toFixed(2) + 'ms'
            });

            pageIndex++;
            return true;
        } catch (error) {
            console.error(`❌ 注入第 ${pageIndex + 1} 页时出错:`, error);
            pageIndex++; // 跳过错误页
            return pageIndex < totalPages;
        }
    };

    /**
     * 检查是否还有更多内容
     * @returns {boolean}
     */
    const hasMore = () => pageIndex < totalPages;

    /**
     * 获取当前注入状态
     * @returns {Object}
     */
    const getStatus = () => {
        return {
            totalPages,                                      // 总页数
            currentPage: pageIndex,                          // 已注入到第几页
            remainingPages: totalPages - pageIndex,          // 剩余页数
            injectedContent: contentHtml.value,              // 当前已注入内容
            remainingContent: validContents.slice(pageIndex).join(""), // 剩余所有页（使用 validContents）
            progress: `${pageIndex}/${totalPages}`,          // 进度字符串
            percentage: totalPages > 0 ? Math.round((pageIndex / totalPages) * 100) : 100, // 百分比
        };
    };

    /**
     * 获取性能统计信息
     * @returns {Object}
     */
    const getPerformanceStats = () => {
        const avgTime = performanceStats.injectionTimes.length > 0
            ? performanceStats.injectionTimes.reduce((a, b) => a + b, 0) / performanceStats.injectionTimes.length
            : 0;
            
        return {
            totalInjections: performanceStats.injectionTimes.length,
            totalTime: performanceStats.totalTime.toFixed(2) + 'ms',
            averageTime: avgTime.toFixed(2) + 'ms',
            minTime: performanceStats.injectionTimes.length > 0 
                ? Math.min(...performanceStats.injectionTimes).toFixed(2) + 'ms' 
                : '0ms',
            maxTime: performanceStats.injectionTimes.length > 0 
                ? Math.max(...performanceStats.injectionTimes).toFixed(2) + 'ms' 
                : '0ms',
            injectionTimes: performanceStats.injectionTimes.map(t => t.toFixed(2) + 'ms'),
        };
    };

    /**
     * 重置注入器状态
     */
    const reset = () => {
        pageIndex = 0;
        contentHtml.value = "";
        performanceStats.injectionTimes = [];
        performanceStats.totalTime = 0;
        performanceStats.startTime = null;
        console.log('🔄 注入器已重置');
    };

    return {
        injectNextChunk,
        hasMore,
        getStatus,
        getPerformanceStats,
        reset,
    };
}

const ORIGINAL_MESSAGE_CONTAINER_CLASS = 'original_message_flags_mail_talk_hz'
const DEFAULT_ORIGINAL_MESSAGE_LABELS = ['Original Message', 'Original Email', '原始邮件']

function normalizeOriginalMessageText(text = '') {
    return text.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase()
}

function extractOriginalMessageCoreText(text = '') {
    const normalizedText = normalizeOriginalMessageText(text)
    const separatorMatch = normalizedText.match(/^[\s\-_=~:|>|<]{4,}\s*(.*?)\s*[\s\-_=~:|>|<]{4,}$/)
    return separatorMatch ? separatorMatch[1].trim() : normalizedText
}

function escapeRegExp(text = '') {
    return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

function matchesOriginalMessageMarker(text = '', label = '') {
    const normalizedText = normalizeOriginalMessageText(text)
    const normalizedLabel = normalizeOriginalMessageText(label)

    if (!normalizedText || !normalizedLabel) return false
    if (extractOriginalMessageCoreText(normalizedText) === normalizedLabel) return true

    const flexibleLabelPattern = escapeRegExp(normalizedLabel).replace(/\s+/g, '\\s*')
    const markerPattern = new RegExp(`^[\\s\\-_=~:|><]{0,}${flexibleLabelPattern}[\\s\\-_=~:|><]{0,}$`, 'i')
    return markerPattern.test(normalizedText)
}

function getOriginalMessageLabels() {
    const translatedLabels = (i18n.global.availableLocales || [])
        .map(locale => i18n.global.getLocaleMessage(locale)?.['common.email.originalMessage'])
        .filter(Boolean)

    return Array.from(new Set(
        [...DEFAULT_ORIGINAL_MESSAGE_LABELS, ...translatedLabels].map(label => normalizeOriginalMessageText(label))
    ))
}

function isOriginalMessageMarkerText(text = '') {
    const normalizedText = normalizeOriginalMessageText(text)
    if (!normalizedText) return false

    return getOriginalMessageLabels().some(label => matchesOriginalMessageMarker(normalizedText, label))
}

function findOriginalMessageBlockElement(node, doc) {
    let el = node.parentElement

    while (el && el !== doc.body) {
        if (el.classList?.contains(ORIGINAL_MESSAGE_CONTAINER_CLASS)) {
            return el
        }
        el = el.parentElement
    }

    el = node.parentElement
    let candidate = el

    while (el && el !== doc.body) {
        const tagName = el.tagName
        if (['DIV', 'BLOCKQUOTE', 'TABLE', 'TR', 'TD', 'SECTION', 'ARTICLE'].includes(tagName)) {
            candidate = el
        }
        el = el.parentElement
    }

    return candidate
}

function getOriginalMessageBlockElements(doc) {
    const blockElements = []
    const seenElements = new Set()

    const addBlockElement = (el) => {
        if (el && !seenElements.has(el)) {
            seenElements.add(el)
            blockElements.push(el)
        }
    }

    doc.querySelectorAll(`.${ORIGINAL_MESSAGE_CONTAINER_CLASS}`).forEach(addBlockElement)

    const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT, null)
    let textNode

    while ((textNode = walker.nextNode())) {
        if (!isOriginalMessageMarkerText(textNode.nodeValue)) continue
        addBlockElement(findOriginalMessageBlockElement(textNode, doc))
    }

    return blockElements
}

/**
 * 调试工具：分析 HTML 内容的统计信息
 * @param {string} html - HTML 字符串
 * @returns {Object} 统计信息
 */
export function analyzeHtmlContent(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const originalMessageBlocks = getOriginalMessageBlockElements(doc);
    
    const stats = {
        totalLength: html.length,
        totalElements: doc.querySelectorAll('*').length,
        divCount: doc.querySelectorAll('div').length,
        tableCount: doc.querySelectorAll('table').length,
        imgCount: doc.querySelectorAll('img').length,
        linkCount: doc.querySelectorAll('a').length,
        textLength: doc.body.textContent?.length || 0,
        hasOriginalMessage: originalMessageBlocks.length > 0,
    };
    
    return stats;
}

// export function splitHtmlByOriginalMessage(html, span = 3, includeBeforeBlock0 = false) {
//     const parser = new DOMParser();
//     const doc = parser.parseFromString(html, "text/html");
//
//     // 找到所有 block（marker 的父节点）
//     const markers = Array.from(doc.querySelectorAll("*")).filter((el) => el.textContent.trim() === "------------------ Original Message ------------------");
//
//     // ❗ 若没有任何 marker，表示内容中并没有 block —— 无需切割，返回整段内容
//     if (markers.length === 0) {
//         return {
//             blocks: [], contents: [html],  // 直接整个内容放入 contents
//             positions: []
//         };
//     }
//
//     // 找到所有 block HTML（父元素）
//     const blocks = markers.map((m) => m.parentElement.outerHTML);
//
//     // 顺序查找 block 在 html 中的位置
//     const positions = [];
//     let searchPos = 0;
//
//     for (let i = 0; i < blocks.length; i++) {
//         const block = blocks[i];
//         let pos = html.indexOf(block, searchPos);
//
//         // indexOf 找不到时做一次容错
//         if (pos === -1) pos = html.indexOf(block);
//
//         positions.push(pos);
//
//         // 下次搜索从当前 block 后继续
//         searchPos = pos + block.length;
//     }
//
//     const contents = [];
//
//     // block0 之前的 HTML 作为 prefix（可选）
//     const prefix = includeBeforeBlock0 && positions[0] > 0 ? html.slice(0, positions[0]) : "";
//
//     // ⚡按 span 分组切片
//     for (let i = 0; i < blocks.length; i += span) {
//         const start = positions[i];
//
//         // 下一组的 block 位置
//         const nextIndex = i + span;
//         const end = nextIndex < positions.length ? positions[nextIndex] : html.length;
//
//         let content = html.slice(start, end);
//
//         // 第一组加 prefix
//         if (i === 0 && prefix) {
//             content = prefix + content;
//         }
//
//         contents.push(content);
//     }
//
//     return {blocks, contents, positions};
// }

/**
 * 优化版：根据 "Original Message" 标记分割 HTML，支持精准分页
 * @param {string} html - 原始 HTML 字符串
 * @param {number} span - 每页包含多少个 block（默认 3）
 * @param {boolean} includeBeforeBlock0 - 是否将第一个 block 之前的内容包含在第一页
 * @returns {{blocks: string[], contents: string[], positions: number[]}}
 */
export function splitHtmlByOriginalMessage(
    html,
    span = 3,
    includeBeforeBlock0 = false
) {
    // ✅ 增加空值检查
    if (!html || typeof html !== 'string' || html.trim() === '') {
        console.warn('⚠️ splitHtmlByOriginalMessage: HTML内容为空');
        return {
            blocks: [],
            contents: [],
            positions: [],
        };
    }
    
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const blockElements = getOriginalMessageBlockElements(doc);
    console.log(blockElements,'blockElements')
    // 没有 marker：不切割，返回整段内容
    if (blockElements.length === 0) {
        return {
            blocks: [],
            contents: [html],
            positions: [],
        };
    }

    /* --------------------------------------------------
     * 3️⃣ 为每个 block 添加唯一标记，便于精准定位
     * -------------------------------------------------- */
    const UNIQUE_MARKER_PREFIX = `__SPLIT_MARKER_${Date.now()}_`;
    
    blockElements.forEach((el, index) => {
        el.setAttribute('data-split-marker', `${UNIQUE_MARKER_PREFIX}${index}`);
    });

    // 重新序列化 HTML（包含标记）
    const markedHtml = doc.body.innerHTML;

    /* --------------------------------------------------
     * 4️⃣ 使用正则表达式精准定位每个 block 的位置
     * -------------------------------------------------- */
    const positions = [];
    const blocks = [];

    for (let i = 0; i < blockElements.length; i++) {
        const marker = `${UNIQUE_MARKER_PREFIX}${i}`;
        const regex = new RegExp(`<[^>]*data-split-marker="${marker}"[^>]*>`, 'i');
        const match = markedHtml.match(regex);

        if (match) {
            const pos = match.index;
            positions.push(pos);
            
            // 获取 block 的 HTML（移除标记属性）
            const blockHtml = blockElements[i].outerHTML.replace(
                /\s*data-split-marker="[^"]*"/gi,
                ''
            );
            blocks.push(blockHtml);
        }
    }

    // 清理标记后的 HTML
    const cleanHtml = markedHtml.replace(/\s*data-split-marker="[^"]*"/gi, '');

    /* --------------------------------------------------
     * 5️⃣ 按 span 分组切片（优化版）
     * -------------------------------------------------- */
    const contents = [];

    // 第一个 block 之前的内容
    const prefix = includeBeforeBlock0 && positions.length > 0 && positions[0] > 0
        ? cleanHtml.slice(0, positions[0])
        : "";

    // ✅ 改进空位置处理
    if (positions.length === 0 || positions.every(pos => pos === -1 || pos === undefined || pos === null)) {
        console.warn('⚠️ splitHtmlByOriginalMessage: 未找到有效的block位置');
        return {
            blocks: [],
            contents: [html],  // 返回原始HTML
            positions: [],
        };
    }

    // 按 span 分组
    for (let i = 0; i < positions.length; i += span) {
        const start = positions[i];
        const nextIndex = i + span;
        const end = nextIndex < positions.length ? positions[nextIndex] : cleanHtml.length;

        let content = cleanHtml.slice(start, end);

        // 第一组加上 prefix
        if (i === 0 && prefix) {
            content = prefix + content;
        }

        // 确保内容不为空
        if (content.trim()) {
            contents.push(content);
        }
    }

    /* --------------------------------------------------
     * 6️⃣ 验证和修复 HTML 完整性
     * -------------------------------------------------- */
    const validatedContents = contents.map(content => {
        return ensureHtmlIntegrity(content);
    });

    return {
        blocks,
        contents: validatedContents,
        positions,
    };
}

export function splitHtmlAtFirstOriginalMessage(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html || '', "text/html");
    const splitTarget = findFirstOriginalMessageSplitTarget(doc);

    if (!splitTarget) {
        return {
            hasOriginalMessage: false,
            translatableHtml: html,
            originalMessageHtml: '',
        };
    }

    const markerAttr = 'data-translate-original-message-marker';
    const markerValue = `__MAIL_TRANSLATE_MARKER_${Date.now()}__`;
    splitTarget.setAttribute(markerAttr, markerValue);

    const translatableDoc = parser.parseFromString(doc.body.innerHTML, "text/html");
    const originalMessageDoc = parser.parseFromString(doc.body.innerHTML, "text/html");
    const translatableTarget = translatableDoc.body.querySelector(`[${markerAttr}="${markerValue}"]`);
    const originalMessageTarget = originalMessageDoc.body.querySelector(`[${markerAttr}="${markerValue}"]`);

    if (!translatableTarget || !originalMessageTarget) {
        return {
            hasOriginalMessage: false,
            translatableHtml: html,
            originalMessageHtml: '',
        };
    }

    trimNodeAndFollowing(translatableTarget, translatableDoc.body, true);
    trimNodeAndPrevious(originalMessageTarget, originalMessageDoc.body);

    translatableDoc.body.querySelectorAll(`[${markerAttr}]`).forEach(node => node.removeAttribute(markerAttr));
    originalMessageDoc.body.querySelectorAll(`[${markerAttr}]`).forEach(node => node.removeAttribute(markerAttr));

    return {
        hasOriginalMessage: true,
        translatableHtml: translatableDoc.body.innerHTML,
        originalMessageHtml: originalMessageDoc.body.innerHTML,
    };
}

function findFirstOriginalMessageSplitTarget(doc) {
    if (!doc?.body) return null;

    const walker = doc.createTreeWalker(
        doc.body,
        NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT,
        null
    );

    let currentNode = doc.body;

    while (currentNode) {
        if (currentNode.nodeType === Node.ELEMENT_NODE) {
            const element = currentNode;

            if (element !== doc.body && element.classList?.contains(ORIGINAL_MESSAGE_CONTAINER_CLASS)) {
                return element;
            }

            if (element !== doc.body && isOriginalMessageMarkerElement(element)) {
                return element;
            }
        }

        if (currentNode.nodeType === Node.TEXT_NODE && isOriginalMessageMarkerText(currentNode.nodeValue)) {
            return findOriginalMessageMarkerTextContainer(currentNode, doc);
        }

        currentNode = walker.nextNode();
    }

    return null;
}

function isOriginalMessageMarkerElement(element) {
    if (!element || !element.textContent) return false;
    if (element.children.length && Array.from(element.children).some(child => isOriginalMessageMarkerElement(child))) {
        return false;
    }

    return isOriginalMessageMarkerText(element.textContent);
}

function findOriginalMessageMarkerTextContainer(node, doc) {
    let current = node.parentElement;
    let candidate = current;

    while (current && current !== doc.body) {
        const parent = current.parentElement;
        if (!parent || parent === doc.body) {
            break;
        }

        if (!isOriginalMessageMarkerText(parent.textContent || '')) {
            break;
        }

        candidate = parent;
        current = parent;
    }

    return candidate || node.parentElement;
}

function trimNodeAndFollowing(node, root, removeSelf = false) {
    let current = node;

    while (current && current !== root) {
        const parent = current.parentNode;
        if (!parent) break;

        let nextSibling = current.nextSibling;
        while (nextSibling) {
            const nodeToRemove = nextSibling;
            nextSibling = nextSibling.nextSibling;
            parent.removeChild(nodeToRemove);
        }

        if (removeSelf) {
            parent.removeChild(current);
        }

        current = parent;
        removeSelf = false;
    }
}

function trimNodeAndPrevious(node, root) {
    let current = node;

    while (current && current !== root) {
        const parent = current.parentNode;
        if (!parent) break;

        let previousSibling = current.previousSibling;
        while (previousSibling) {
            const nodeToRemove = previousSibling;
            previousSibling = previousSibling.previousSibling;
            parent.removeChild(nodeToRemove);
        }

        current = parent;
    }
}

/**
 * 确保 HTML 片段的标签完整性
 * @param {string} html - HTML 片段
 * @returns {string} - 修复后的 HTML
 */
function ensureHtmlIntegrity(html) {
    if (!html || !html.trim()) {
        return html;
    }

    // ✅ 第一步：清理开头和结尾可能被截断的标签片段
    let cleanedHtml = html;
    
    // 清理开头的残缺标签（如：e="..." 或 style="...）
    // 匹配模式：以属性名或属性值开头的残缺内容
    cleanedHtml = cleanedHtml.replace(/^[^<]*?=\s*"[^"]*?"[^<>]*?>/i, '');
    
    // 清理开头的其他残缺内容（以 > 开头或属性片段）
    cleanedHtml = cleanedHtml.replace(/^[^<>]*?>/, '');
    
    // 清理结尾被截断的标签（如：...style="mso-margin）
    cleanedHtml = cleanedHtml.replace(/<[^>]*$/, '');
    
    // ✅ 移除 Microsoft Office 命名空间标签，避免产生不必要的换行
    // 这些标签会被浏览器解析成空元素，导致额外的换行
    cleanedHtml = cleanedHtml.replace(/<o:p>\s*<\/o:p>/gi, '');
    cleanedHtml = cleanedHtml.replace(/<o:p>/gi, '');
    cleanedHtml = cleanedHtml.replace(/<\/o:p>/gi, '');
    
    // 移除其他常见的 Office 命名空间标签
    cleanedHtml = cleanedHtml.replace(/<\/?[ovwxm]:[^>]*>/gi, '');

    const parser = new DOMParser();
    const doc = parser.parseFromString(cleanedHtml, "text/html");
    
    // 检查是否有解析错误
    const parserError = doc.querySelector('parsererror');
    if (parserError) {
        console.warn('⚠️ HTML parsing error detected, attempting to fix...');
        // 如果有解析错误，尝试用 div 包裹
        const wrappedDoc = parser.parseFromString(`<div>${cleanedHtml}</div>`, "text/html");
        let result = wrappedDoc.body.innerHTML;
        
        // 再次清理可能的残缺内容
        result = result.replace(/^[^<>]*?>/, '').replace(/<[^>]*$/, '');
        return result;
    }
    
    // 获取规范化的 HTML
    let result = doc.body.innerHTML;
    
    // ✅ 移除开头的任何残缺文本节点
    result = result.replace(/^[^<]+?(?=<)/, (match) => {
        // 如果匹配到的是正常文本（包含完整单词），保留它
        if (/\b[A-Za-z]{3,}\b/.test(match)) {
            return match;
        }
        // 否则是残缺的属性片段，删除它
        console.log('🧹 清理残缺片段:', match.substring(0, 50));
        return '';
    });
    
    // ✅ 清理开头连续的空段落和换行（保留第一个作为间距）
    // 匹配开头的多个 <p></p>、<p> </p>、<br>、<p class="..."></p> 等
    result = result.replace(/^(\s*<(?:p[^>]*>[\s\u00a0]*<\/p>|br\s*\/?>)){2,}/gi, (match) => {
        // 保留一个空段落作为间距，删除其余的
        console.log('🧹 清理多余的空段落:', match.substring(0, 80));
        return '<p></p>';
    });
    
    // ✅ 特别处理：移除开头的 tiny_edit_br_simulation_p_original_message 空段落
    // 这些段落有特殊的 line-height，会产生不必要的空白
    result = result.replace(/^(\s*<p\s+class=["']tiny_edit_br_simulation_p_original_message["'][^>]*>[\s\u00a0]*<\/p>\s*)+/gi, '');
    
    return result;
}

/**
 * 智能计算最佳分页大小
 * @param {string} html - HTML 字符串
 * @param {number} markerCount - Original Message 标记数量
 * @param {number} defaultSpan - 默认每页包含的 block 数
 * @returns {number} - 优化后的 span 值
 */
export function calculateOptimalSpan(html, markerCount, defaultSpan) {
    const htmlLength = html.length;
    const safeDefaultSpan = Math.max(defaultSpan || 1, 1);
    const safeMarkerCount = Math.max(markerCount || 0, 0);
    
    if (safeMarkerCount === 0) {
        return safeDefaultSpan;
    }
    
    // 如果内容很小（< 50KB），不需要分页
    if (htmlLength < 50000) {
        return safeMarkerCount; // 一次性加载所有
    }
    
    // 如果内容中等（50KB - 200KB），使用默认分页
    if (htmlLength < 200000) {
        return safeDefaultSpan;
    }
    
    // 如果内容很大（> 200KB），使用更小的分页
    if (htmlLength < 500000) {
        return Math.max(1, Math.floor(safeDefaultSpan / 2));
    }
    
    // 超大内容，每次只加载 1 个 block
    return 1;
}


export function moveEmptyToEndAndSort(list) {
    return list.slice().sort((a, b) => {
        if (a === '' && b !== '') return 1
        if (a !== '' && b === '') return -1
        return a.localeCompare(b)
    })
}

export function productSortSwitch(productSort) {
    switch (productSort) {
        case 1:
            return "userinfo.vip.service.1";
        case 2:
            return "userinfo.vip.service.2";
        case 3:
            return "userinfo.vip.service.3";
        case 4:
            return "userinfo.vip.service.4"
        case 5:
            return "common.generaluser.pro";
        case 6:
            return "vip.type.1";
        case 7:
            return "vip.type.2";
        case 8:
            return "vip.type.3"
        default:
            return "common.unknown"
    }
}


/**
 * 截取 HTML 前 n 个“可见字符”，并保证标签闭合
 * @param {string} html 原始 html
 * @param {number} maxLength 可见字符数
 * @returns {string}
 */
export function sliceHtmlSafely(html, maxLength = 10) {
    let visibleCount = 0
    let cutIndex = html.length

    // 第一步：找到可见字符的截断位置
    for (let i = 0; i < html.length; i++) {
        if (html[i] === '<') {
            i = html.indexOf('>', i)
            if (i === -1) break
            continue
        }

        visibleCount++
        if (visibleCount === maxLength) {
            cutIndex = i + 1
            break
        }
    }

    let result = html.slice(0, cutIndex)

    // 第二步：如果标签没闭合，继续往后截
    const openTags = (result.match(/<[^\/!][^>]*>/g) || []).length
    const closeTags = (result.match(/<\/[^>]+>/g) || []).length

    if (openTags > closeTags) {
        let rest = html.slice(cutIndex)
        let need = openTags - closeTags

        const closeTagRegex = /<\/[^>]+>/g
        let match

        while (need > 0 && (match = closeTagRegex.exec(rest))) {
            result += match[0]
            need--
        }
    }

    return result
}
